import React from "react";

const Fields = () => {
  return <div>Fields</div>;
};

export default Fields;
